import React from 'react';
import { cn } from '../../utils/cn';

export function Card({ className, ...props }) {
    return (
        <div
            className={cn(
                'bg-white text-slate-900 flex flex-col gap-6 rounded-xl border border-slate-200 py-6 shadow-sm',
                className
            )}
            {...props}
        />
    );
}

export function CardHeader({ className, ...props }) {
    return (
        <div
            className={cn(
                'grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-[data-slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6',
                className
            )}
            {...props}
        />
    );
}

export function CardTitle({ className, ...props }) {
    return <div className={cn('leading-none font-semibold text-slate-900', className)} {...props} />;
}

export function CardDescription({ className, ...props }) {
    return <div className={cn('text-slate-600 text-sm', className)} {...props} />;
}

export function CardAction({ className, ...props }) {
    return (
        <div className={cn('col-start-2 row-span-2 row-start-1 self-start justify-self-end', className)} {...props} />
    );
}

export function CardContent({ className, ...props }) {
    return <div className={cn('px-6', className)} {...props} />;
}

export function CardFooter({ className, ...props }) {
    return <div className={cn('flex items-center px-6 [.border-t]:pt-6', className)} {...props} />;
}
